export enum UserDisplayableApiErrorMessage {
  NO_UNITS_AVAILABLE = 'api.exception.no_units_available',
  UNIT_UNAVAILABLE = 'api.exception.unit_unavailable',
  NO_LOCKERS_AVAILABLE = 'api.exception.no_lockers_available',
  INVALID_DOMAIN_NAME = 'api.exception.invalid_domain_name',
  WORKFLOW_NOT_ACTIVE = 'api.exception.workflow_not_active',
  WORKFLOW_NOT_FOUND = 'api.exception.workflow_not_found',
  INVALID_OCCUPANCY_DURATION = 'api.exception.invalid_occupancy_duration',
  RENTAL_IN_OVERTIME = 'api.exception.rental_in_overtime',
  RENTAL_NOT_ONGOING = 'api.exception.rental_not_ongoing',
  RENTAL_ALREADY_HAS_AUTHENTICATION_TYPE = 'api.exception.rental_already_has_authentication_type',
  INVALID_AUTHENTICATION_CODE = 'api.exception.invalid_authentication_code',
  CART_EXPIRED = 'api.exception.cart_expired',
  ORDER_CANCELLED = 'api.exception.order_cancelled',
  ORDER_ALREADY_PAID = 'api.exception.order_already_paid',
  ORDER_PAYMENT_EXPIRED = 'api.exception.order_payment_expired',
  RESERVATION_TOKEN_INVALID = 'api.exception.reservation_token_invalid',
  RESERVATION_ALREADY_IN_USE = 'api.exception.reservation_already_in_use',
  RESERVATION_PICKUP_NOT_ALLOWED = 'api.exception.reservation_pickup_not_allowed',
  ORDER_STATE_INVALID = 'api.exception.order_state_invalid',
  ORDER_ITEM_STATE_INVALID = 'api.exception.order_item_state_invalid',
  LOCKER_OPENING_FAILED = 'api.exception.locker_opening_failed',
}
